export default __webpack_public_path__ + "static/media/welcomeStep6.a53c5a70.png";